import React, { useEffect, useState } from "react";
import style from "../../DetailContainer.module.scss";
import { GrDocumentText } from "react-icons/gr";
import {
  dateFormateDD,
  decryptedAdminID,
  getMainStageBadge,
  getSu,
  getSubStageBadge,
  getSubStageBadgebStageBadgegetSubStageBadge,
} from "../../../../utility";
import { BsPencilSquare, BsThreeDotsVertical } from "react-icons/bs";
import { Autocomplete, MenuItem, Popover, TextField } from "@mui/material";
import { getAdminIds } from "../../../../services/candidateServices";
import { AiOutlineClose } from "react-icons/ai";
import { MyModal } from "../../../Common/Model/MyModal";
import ModalContainer from "../../../Common/Model/ModalContainer";
import { updateInterviewAdminID } from "../../../../services/interviewServices";
import { useSelector } from "react-redux";
import SuccessTick from "../../../success_tick";
import {
  UpdatejoiningCtc,
  UpdatejoiningDayPipelineStatus,
} from "../../../../apiServices";

function Interviews({ data = [], reloadInterviews }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";
  const [assignOpen, setAssignOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedInterviewId, setSelectedInterviewId] = useState(null);
  const [currentAdminId, setCurrentAdminId] = useState(null);
  const [showCtcEdit, setShowCtctEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enableSubmit, setenableSubmit] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [joinedId, setjoinedId] = useState("");
  const open = Boolean(anchorEl);
  useEffect(() => {
    console.log(data);
  }, [data]);

  const handleMenuClick = (event, id, adminId) => {
    setAnchorEl(event.currentTarget);
    setSelectedInterviewId(id);
    setCurrentAdminId(adminId); // ✅ store current admin
  };
const hasJoinedCtc =  data && Array.isArray(data) && data.some(doc => Number(doc.current_stage_id) === 27);

  const [interviewStatus, setInterviewStatus] = useState({
    caninterviewid: "",
    statusfield: "",
    date: null,
    notes: [],
    replaceCandidate: "",
    ctc: "",
  });

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchAdmins = async () => {
    try {
      const res = await getAdminIds({
        id: decryptedAdminID(),
        onlyMe: false,
      });

      // ✅ ensure array
      const list = Array.isArray(res) ? res : res?.data || res?.result || [];

      setAdminList(list);
    } catch (err) {
      console.error(err);
      setAdminList([]); // fallback
    }
  };

  const handleAdminChange = (_, value) => {
    console.log(value, "assignTo id");

    setSelectedAdmin(value);
  };
  const handleAssign = async () => {
    if (!selectedAdmin) {
      alert("Select admin");
      return;
    }

    if (!selectedInterviewId) {
      alert("No interview selected");
      return;
    }

    try {
      setLoading(true);

      await updateInterviewAdminID({
        id: selectedInterviewId,
        admin_id: selectedAdmin.admin_id,
      });
      setOpenSuccess(true);
      setAssignOpen(false);
      setSelectedAdmin(null);
      setSelectedInterviewId(null);
      setTimeout(() => setOpenSuccess(false), 2000);
      reloadInterviews && reloadInterviews();
    } catch (err) {
      console.error(err);
      alert("Assign failed");
    } finally {
      setLoading(false);
    }
  };

const submitCtc = async (e) => {
  e.preventDefault();
  setenableSubmit(true);
  
  let obj = {
    id: joinedId,
    ctc: interviewStatus.ctc,
  };
  
  setShowSuccess(true);
  
  try {
    const response = await UpdatejoiningCtc(obj);
    console.log(response, "response");
    
    // if (reloadInterviews) {
    //   await reloadInterviews();
    // }
    
    setTimeout(() => {
      setenableSubmit(false);
      setShowSuccess(false);
      setShowCtctEdit(false);
    }, 2000);
         reloadInterviews && reloadInterviews();
  } catch (error) {
    console.error("Error updating CTC:", error);
    alert("Failed to update CTC. Please try again.");
    setenableSubmit(false);
    setShowSuccess(false);
  }
};
  return (
    <>
      <div className={style.interviewContainer}>
        <div className={style.title}>Interview for this Candidate</div>

        {/* ✅ TABLE */}
        {data?.length > 0 ? (
          <div className={style.tableContainer}>
            {/* TABLE */}

            <table className={style.candidateTable}>
              <thead>
                <tr className={style.trWrapper}>
                  <th>Interview ID</th>
                  <th>Job Category</th>
                  <th>Interview Date</th>
                  <th>Scheduled by</th>
                  {/* <th>CTC (in rupees)</th> */}
                   {hasJoinedCtc && <th>CTC (in rupees)</th>}
                  <th>Status</th>
                </tr>
              </thead>

              <tbody className={style.tableBody}>
                {data.map((doc) => {
                  const subStageLabel = doc.current_sub_stage_name || "";
                  const subBadge = getSubStageBadge(subStageLabel);
                  const cleanedStage = doc.current_stage_name?.replace(
                    /Interview\s*/i,
                    "",
                  );
                  const mainBadge = getMainStageBadge(cleanedStage);
                      const isJoined = data?.some?.(doc => Number(doc.current_stage_id) === 27) || false;

                  return (
                    <tr key={doc.id}>
                      {/* ID */}
                      <td>{doc.id}</td>

                      {/* JOB CATEGORY */}
                      <td>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>
                            <b>{doc.job_category}</b>
                          </span>
                          <span style={{ fontSize: "12px", color: "#666" }}>
                            {doc.Job_company_name}
                          </span>
                        </div>
                      </td>

                      {/* DATE */}
                      <td>{dateFormateDD(doc.interview_date)}</td>

                      {/* ADMIN */}
                      <td>
                        <div className="d-flex align-items-center">
                          <span className={style.assignedTo}>
                            <span className={style.assignedToFirstLetter}>
                              {doc.user_name?.charAt(0)?.toUpperCase() || "?"}
                            </span>
                            <span className="me-1">
                              {doc.user_name || "Unknown"}
                            </span>
                          </span>
                        </div>
                      </td>

                      {/* CTC (in rupees) - ADD CLICK HANDLER */}
                             {hasJoinedCtc && (
          <td>
            {isJoined ? (
              <div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                <BsPencilSquare
                  className="text-success me-2 fs-5"
                  onClick={() => {
                    setjoinedId(doc.id);
                    setShowCtctEdit(true);
                    setInterviewStatus(prev => ({ ...prev, ctc: doc.ctc || "" }));
                  }}
                />
                {doc.ctc ? `₹${Number(doc.ctc).toLocaleString('en-IN')}` : '-'}
              </div>
            ) : (
              <span>-</span>
            )}
          </td>
        )}


                      {/* STAGE */}
                      <td>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {/* Badge */}
                          <span
                            style={{
                              backgroundColor: subStageLabel
                                ? subBadge.bg
                                : mainBadge?.bg || "#eeeeee",
                              color: subStageLabel
                                ? subBadge.color
                                : mainBadge?.color || "#333",
                              padding: "4px 8px",
                              borderRadius: "6px",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            {subStageLabel
                              ? `${cleanedStage} - ${subBadge.label}`
                              : mainBadge?.label || "No Stage"}
                          </span>

                          {/* Three dots */}
                          {(isSuperAdmin || isTeamLeader) && (
                            <div style={{ position: "relative" }}>
                              <BsThreeDotsVertical
                                onClick={(e) =>
                                  handleMenuClick(e, doc.id, doc.admin_id)
                                } // ✅ pass admin_id
                                style={{ cursor: "pointer" }}
                              />

                              <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                              >
                                <div
                                  style={{ padding: "10px", minWidth: "180px" }}
                                >
                                  <MenuItem
                                    onClick={() => {
                                      handleClose();
                                      setAssignOpen(true);
                                      fetchAdmins();
                                    }}
                                  >
                                    Assign To
                                  </MenuItem>
                                </div>
                              </Popover>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={style.activitiesBodyContainer}>
            <h6>
              <b>No Interviews</b>
            </h6>
          </div>
        )}
      </div>
      {assignOpen && (
        <MyModal>
          <ModalContainer>
            <div>
              <div className="d-flex justify-content-between">
                <b>Assign To</b>
                <button
                  onClick={() => setAssignOpen(false)}
                  className={style.cancelButton}
                >
                  <AiOutlineClose />
                </button>
              </div>

              <div className="mt-3">
                <Autocomplete
                  options={adminList || []}
                  getOptionLabel={(opt) => opt?.user_name || ""}
                  value={selectedAdmin}
                  onChange={handleAdminChange}
                  getOptionDisabled={(option) =>
                    option.admin_id === currentAdminId
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Admin" />
                  )}
                />
              </div>

              <div className="mt-3 text-end">
                <button
                  onClick={handleAssign}
                  disabled={loading}
                  className={style.primaryButton}
                >
                  {loading ? "Assigning..." : "Assign"}
                </button>
              </div>
            </div>
          </ModalContainer>
        </MyModal>
      )}

      {showCtcEdit && (
        <MyModal>
          <ModalContainer>
            <div style={{
              // width: "400px",
              // padding: "20px",
              backgroundColor: "white",
              borderRadius: "8px"
            }}>
              <form onSubmit={submitCtc}>
                <div className="text-center mb-3">
                  <b>Update CTC</b>
                </div>
                <div className="mb-3">
                  <label htmlFor="ctc" className="mb-1">
                    <b>Enter CTC : </b>
                  </label>
                  <input
                    type="text"
                    id="ctc"
                    name="ctc"
                    className="form-control"
                    onChange={(e) =>
                      setInterviewStatus((prev) => ({
                        ...prev,
                        ctc: e.target.value,
                      }))
                    }
                    value={interviewStatus.ctc}
                    maxLength={7}
                    required
                    pattern="\d+"
                    title="Please enter a valid CTC (numbers only)."
                  />
                </div>
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCtctEdit(false);
                    }}
                    className="btn btn-danger"
                  >
                    No
                  </button>
                  <button type="submit" className="btn btn-success">
                    Yes
                  </button>
                </div>
              </form>
            </div>
          </ModalContainer>
        </MyModal>
      )}

      {openSuccess && (
        <MyModal>
          <ModalContainer>
            <SuccessTick HeadText={"Successfully Changed!"} />
          </ModalContainer>
        </MyModal>
      )}
       {showSuccess && (
                 <MyModal>
          <ModalContainer>
            <SuccessTick HeadText={"Successfully Updated"} />
          </ModalContainer>
        </MyModal>
              )}
    </>
  );
}

export default Interviews;
